<template>
	<div class="grid-toolbar">
		<span class="view-title">{{ gridViewName }}</span>
		<quick-filter
			:Columns="visibleColumns"
			:filter="quickFilter"
			@filterChanged="onQuickFilterChanged"
		/>
		<!-- Desktop Only Elements (≥lg) -->
		<div
			class="d-none d-sm-none d-md-none d-lg-flex d-xl-flex align-center"
		>
			<v-badge
				:value="advancedFilter.FiltersCount > 0"
				left
				bordered
				overlap
				class="mr-2"
			>
				<template v-slot:badge>
					<span style="color: white">{{
						advancedFilter.FiltersCount
					}}</span>
				</template>
				<v-btn color="primary" @click="onShowAdvancedFilter">
					<v-icon class="mr-1">mdi-magnify</v-icon>
					Advanced search
				</v-btn>
			</v-badge>

			<export-modal
				:timezone-options="true"
				:execution-options="false"
				:data-scope-options="true"
				@exportModalEvent="onExportModalEvent"
			>
				<template #activator="{ on, attrs }">
					<v-btn v-bind="attrs" v-on="on" color="primary">
						<v-icon class="mr-1">mdi-cloud-download</v-icon>
						Export
					</v-btn>
				</template>
			</export-modal>
		</div>

		<!-- Mobile/Tablet Dots Menu (<lg) -->
		<v-menu
			v-model="dotsMenuOpen"
			offset-y
			:close-on-content-click="false"
			class="d-flex d-sm-flex d-md-flex d-lg-none d-xl-none"
			><template v-slot:activator="{ on, attrs }">
				<v-btn
					v-bind="attrs"
					v-on="on"
					color="primary"
					class="d-flex d-sm-flex d-md-flex d-lg-none d-xl-none"
				>
					<v-icon>mdi-dots-vertical</v-icon>
				</v-btn>
			</template>
			<v-list>
				<v-list-item @click="onAdvancedSearchFromDots">
					<v-list-item-content>
						<v-list-item-title>
							<v-icon small left>mdi-magnify</v-icon>
							Advanced search
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<export-modal
					:timezone-options="true"
					:execution-options="false"
					:data-scope-options="true"
					@exportModalEvent="onExportModalEventFromDots"
				>
					<template #activator="{ on, attrs }">
						<v-list-item v-bind="attrs" v-on="on">
							<v-list-item-content>
								<v-list-item-title>
									<v-icon small left
										>mdi-cloud-download</v-icon
									>
									Export
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>
				</export-modal>
			</v-list>
		</v-menu>

		<manage-fields-dialog
			v-if="manageFieldsDialog"
			:showDialog="manageFieldsDialog"
			:hiddenColumns="hiddenColumns"
			:visibleColumns="visibleColumns"
			@close="onManageFieldsDialogClosed"
			@save="onManageFieldsDialogUpdate"
		/>
		<save-view-dialog
			v-if="saveViewDialog"
			:saveViewStoreAction="saveViewAction"
			:showDialog="saveViewDialog"
			@close="onSaveViewDialogClose"
		/>
		<filters-dialog
			v-if="showAdvancedFilter"
			:dialog="showAdvancedFilter"
			:filter="advancedFilter"
			:columns="visibleColumns"
			@filterChanged="onAdvancedFilterChanged"
		/>
	</div>
</template>
<script>
import QuickFilter from '../../shared/gridViews/QuickFilter.vue';
import FiltersDialog from '../../shared/gridViews/FiltersDialog.vue';
import SaveViewDialog from '../../shared/gridViews/SaveViewDialog.vue';
import ManageFieldsDialog from '../../shared/gridViews/ManageFieldsDialog.vue';
import ExportModal from '../../shared/export/ExportModal.vue';
import { ReportGridActions } from '../../../store/actions';
import { ReportGridGetters } from '../../../store/getters';
import { mapGetters } from 'vuex';
export default {
	name: 'ReportGridToolbar',
	props: {
		quickFilter: Object,
		advancedFilter: Object,
		visibleColumns: Array,
		hiddenColumns: Array,
	},
	components: {
		QuickFilter,
		FiltersDialog,
		ExportModal,
		SaveViewDialog,
		ManageFieldsDialog,
	},

	computed: {
		...mapGetters({
			gridView: [ReportGridGetters.GRIDVIEW],
		}),
		gridViewName() {
			if (!this.gridView) return null;
			return this.gridView.Name;
		},
	},
	data() {
		return {
			saveViewDialog: false,
			manageFieldsDialog: false,
			saveViewAction: ReportGridActions.ADD_GRIDVIEW,
			showAdvancedFilter: false,
			dotsMenuOpen: false,
		};
	},
	methods: {
		onExportModalEvent(exportConfig) {
			if (exportConfig.allData) {
				this.$store.dispatch(
					ReportGridActions.EXPORT_ALL_DATA,
					exportConfig.timezone === 'utc'
						? 0
						: new Date().getTimezoneOffset() * -1
				);
			} else {
				this.$store.dispatch(
					ReportGridActions.EXPORT_CURRENT_PAGE,
					exportConfig.timezone === 'utc'
						? 0
						: new Date().getTimezoneOffset() * -1
				);
			}
		},
		onAdvancedSearchFromDots() {
			this.dotsMenuOpen = false;
			this.showAdvancedFilter = true;
		},
		onExportModalEventFromDots(exportConfig) {
			this.dotsMenuOpen = false;
			this.onExportModalEvent(exportConfig);
		},
		onShowAdvancedFilter() {
			this.showAdvancedFilter = true;
		},
		openAdvancedSearch() {
			this.showAdvancedFilter = true;
		},
		onQuickFilterChanged(value) {
			this.$emit('quickFilterChanged', value);
		},
		onAdvancedFilterChanged(value) {
			this.$emit('advancedFilterChanged', value);
			this.showAdvancedFilter = false;
		},
		saveView() {
			this.saveViewDialog = true;
		},
		onSaveViewDialogClose() {
			this.saveViewDialog = false;
		},
		updateView() {
			this.$store.dispatch(ReportGridActions.UPDATE_GRIDVIEW);
		},
		manageFields() {
			this.manageFieldsDialog = true;
		},
		onManageFieldsDialogClosed() {
			this.manageFieldsDialog = false;
		},
		onManageFieldsDialogUpdate(value) {
			this.$store
				.dispatch(ReportGridActions.UPDATE_GRID_VIEW_FIELDS, value)
				.then((success) => {
					if (!success) return;
					this.manageFieldsDialog = false;
				});
		},
	},
};
</script>

<style lang="scss">
.grid-toolbar-menu .v-list-group {
	border-top: 1px solid #eee;
	border-bottom: 1px solid #eee;

	.v-list-item__title {
		font-size: 14px;
	}
}

/* Ensure responsive classes work properly by overriding any conflicting CSS */
@media (max-width: 1263px) {
	.grid-toolbar .d-lg-none {
		display: flex !important;
	}
	.grid-toolbar .d-none.d-sm-none.d-md-none.d-lg-flex.d-xl-flex {
		display: none !important;
	}
}

@media (min-width: 1264px) {
	.grid-toolbar .d-lg-none {
		display: none !important;
	}
	.grid-toolbar .d-none.d-sm-none.d-md-none.d-lg-flex.d-xl-flex {
		display: flex !important;
	}
}
</style>
